import { useQuery } from '@tanstack/react-query';
import { useLayoutEffect } from 'react';
import { api } from '../api.js';
import { arenaLighting, arenaThemeProperties } from '../arena-theme.js';

export function ArenaThemeSync() {
  const home = useQuery({ queryKey: ['home'], queryFn: api.home, staleTime: 30_000 });
  const theme = home.data?.user.social?.boardTheme ?? null;
  const themeColor = theme?.color ?? null;
  const themeName = theme?.name ?? null;

  useLayoutEffect(() => {
    const root = document.documentElement;
    if (!themeColor || !themeName) {
      delete root.dataset['arenaTheme'];
      return;
    }
    const properties = arenaThemeProperties(arenaLighting(themeColor));
    root.dataset['arenaTheme'] = themeName;
    Object.entries(properties).forEach(([property, value]) =>
      root.style.setProperty(property, value),
    );
    return () => {
      delete root.dataset['arenaTheme'];
      Object.keys(properties).forEach((property) => root.style.removeProperty(property));
    };
  }, [themeColor, themeName]);

  return null;
}
